module.exports = __webpack_public_path__ + "static/media/EnvPromo-Shot20.9f8358ad.jpg";